import { computed, ref } from 'vue';

export const createFlowEditorDraftGuard = ({
  isLoading,
  workflowName,
  graphPayload,
  discardDialog,
}) => {
  const savedSnapshot = ref('');
  let resolveLeave = null;

  const snapshot = () =>
    JSON.stringify({ name: workflowName.value, graph: graphPayload() });
  const hasUnsavedChanges = computed(
    () =>
      !isLoading.value &&
      Boolean(savedSnapshot.value) &&
      savedSnapshot.value !== snapshot()
  );
  const markSaved = snapshotValue => {
    savedSnapshot.value = snapshotValue || snapshot();
  };
  const settleLeave = allowed => {
    if (!resolveLeave) return;
    const resolve = resolveLeave;
    resolveLeave = null;
    discardDialog.value?.close();
    resolve(allowed);
  };
  const canLeave = () => {
    if (!hasUnsavedChanges.value) return true;
    if (resolveLeave) return false;
    discardDialog.value?.open();
    return new Promise(resolve => {
      resolveLeave = resolve;
    });
  };
  const beforeUnload = event => {
    if (!hasUnsavedChanges.value) return;
    event.preventDefault();
    event.returnValue = '';
  };
  const dispose = () => {
    settleLeave(false);
  };

  return {
    savedSnapshot,
    hasUnsavedChanges,
    snapshot,
    markSaved,
    settleLeave,
    canLeave,
    beforeUnload,
    dispose,
  };
};
